<template>
  <div class="main-content">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">Careers</li>
        <li class="breadcrumb-item"><router-link :to="{name: 'careers'}">Records</router-link></li>
        <li class="breadcrumb-item active">New record</li>
      </ol>
    </div>
    <div class="card">
      <div class="card-body">
        <h3 class="page-title">Create new careers record</h3>
        <form
          v-if="$store.state.permissions.create.vacancies"
          action="/api/admin/careers/save"
          method="POST"
          @submit.prevent="createRecord()"
        >
          <div class="form-group">
            <label>Title</label>
            <input
              :class="{ 'is-invalid': $v.record.title.$error }"
              v-model.trim="record.title"
              class="form-control"
              @input="$v.record.title.$touch()"
            >
            <div v-if="$v.record.title.$error">
              <span
                v-if="!$v.record.title.required"
                class="help-block help-block-error"
              >Field is required</span>
              <span
                v-if="!$v.record.title.minLength"
                class="help-block help-block-error"
              >Title must have at least {{ $v.record.title.$params.minLength.min }} letters.</span>
            </div>
          </div>
          <div class="form-group">
            <label>Content</label>
            <quill-editor ref="blogContentEditor" v-model="record.content"/>
          </div>
          <button type="button" class="btn btn-primary" @click="goBack">Back</button>
          <button type="submit" class="btn btn-success">Create</button>
        </form>
        <div v-else class="card">
          <div class="card-header">
            <h3>You have not permission for do that</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global axios, toastr */
import { required, minLength } from 'vuelidate/lib/validators'
export default {
  name: 'CareersCreate',
  data () {
    return {
      record: {}
    }
  },
  validations: {
    record: {
      title: {
        required,
        minLength: minLength(4)
      }
    }
  },
  methods: {
    createRecord () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let formData = new FormData()
        for (var key in this.record) {
          formData.append(key, this.record[key])
        }

        axios.post('/api/admin/careers/save', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then(response => {
            if (response && response.data && response.data.result === 'ok') {
              this.record = response.data.record
              toastr['success']('Record has been created successfully')
            } else {
              let message = (response && response.data && response.data.message) || 'Something goes wrong'
              toastr['error'](message)
            }
          })
          .catch(error => {
            let message = (error && error.message) || 'Something goes wrong'
            toastr['error'](message)
          })
      }
    },
    goBack () {
      this.$router.push('/admin/careers')
    }
  }
}
</script>

<style>
</style>
